import { render, staticRenderFns } from "./ProfiliCal.vue?vue&type=template&id=f227a98e&scoped=true&"
import script from "./ProfiliCal.vue?vue&type=script&lang=js&"
export * from "./ProfiliCal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f227a98e",
  null
  
)

export default component.exports